import React, { ReactElement, useState, useEffect } from 'react';
import { getEncryptionFormat, useGetDetailDataSimple } from '@/page/detail/views/api';
import SpecLinePop from '@/page/detail/views/content/components/SpecLinePop';
import { ReturnT } from '../../hooks/useGetMore';
import { logShowCartSpecPopup } from '../../logger';

type IProps = {
    showPop: boolean;
    curPopItem: ReturnT['cartShopList'][number]['cartItemList'][number];
    closePop: () => void;
    onConfirm: (sku: any, purchaseQuantity: number) => void;
    isFrom?: string;
    showChangeCount?: boolean;
};

function SpecPop(props: IProps): ReactElement {
    const [pageRawData, setPageRawData] = useState(null);
    const [selectedSpecInfo, setSelectedSpecInfo] = useState({});

    const { showPop = false, closePop, curPopItem, isFrom } = props;

    const { getDetailDataSimple, data: simpleDetail } = useGetDetailDataSimple({
        itemId: curPopItem?.itemId,
        encryptedParam: JSON.stringify(getEncryptionFormat()), // 不能JSON.stringify, 预请求参数需要和这里一致
        sellerUserId: 0,
        merchantId: curPopItem?.skuPromotion?.distributorDiscount ? +(curPopItem?.sellerMerchantId || 0) : Number(curPopItem?.merchantId || 0),
    });

    const resetData = (res, select = true) => {
        const _selectedSpecInfo = {};
        if (res?.data) {
            const detailDataResData = res?.data;
            // 将活动中限购库存更新到sku信息中
            if (detailDataResData?.activityInfo?.skuLimitCount) {
                Object.keys(detailDataResData?.activityInfo?.skuLimitCount)?.forEach((skuId) => {
                    const skuInfo = detailDataResData?.skus?.find((i) => Number(i.skuId) === Number(skuId)) || {};
                    skuInfo.activityLimitCount = detailDataResData?.activityInfo?.skuLimitCount?.[skuId];
                });
            }
            const skus = detailDataResData.skus || [];
            const skuId = curPopItem.skuId;

            // 获取已选的规格
            for (let i = 0; i < skus.length; i++) {
                if (skus[i].skuId === skuId) {
                    const skuSpecs = skus[i].skuSpecs || [];
                    skuSpecs.forEach((skuSpec) => {
                        _selectedSpecInfo[skuSpec.specId] = skuSpec;
                    });
                    break;
                }
            }
            select ? setSelectedSpecInfo({ ..._selectedSpecInfo }) : setSelectedSpecInfo({});
            setPageRawData({ ...detailDataResData });
        }
    };

    useEffect(() => {
        resetData(simpleDetail);
    }, [simpleDetail]);

    useEffect(() => {
        if (showPop) {
            if (simpleDetail?.data?.itemId === curPopItem?.itemId) resetData(simpleDetail, false);
            logShowCartSpecPopup();
            getDetailDataSimple();
        } else {
            setPageRawData({});
            closePop();
        }
    }, [showPop]);

    return (
        <SpecLinePop
            type="confirm"
            showChangeCount={props.showChangeCount || false}
            isPopVisible={showPop}
            pageRawData={pageRawData}
            defaultSelectedItems={selectedSpecInfo}
            closeSpec={closePop}
            isFrom={isFrom}
            onConfirm={props.onConfirm}
            showAfterCouponPrice={!!curPopItem?.skuPromotion?.distributorDiscount}
        />
    );
}

export default SpecPop;
